module.exports = __webpack_public_path__ + "img/55200.4f4bcd89.jpg";